<div
	class="max-h-75 outline-none"
	[ngClass]="loading() ? 'overflow-hidden' : 'overflow-y-auto'"
	#optionsList
	(scroll)="onScroll()"
	(keydown)="onKeyDown($event)"
	tabindex="0"
>
	@if (groupedOptions() && groupedOptions().length) {
		@for (group of groupedOptions(); track group.name) {
			<div [hidden]="loading()">
				@if (group.name) {
					<div
						class="flex h-10 text-primary-900 font-semibold user-select-none items-center px-4"
						(click)="onGroupToggle(group)"
						[ngClass]="{
							'cursor-pointer!': groupSelectable() && !group.isDisabled,
							'text-primary-400': group.isDisabled,
						}"
						[class.is-disabled]="group.isDisabled"
					>
						{{ translateGroupName(group.name) }}
					</div>
				}

				@for (option of group.options; track $index) {
					<div>
						<ui-select-option
							[option]="option"
							[disabled]="option.isDisabled"
							[multiEnabled]="multiEnabled()"
							[selected]="compareFn(option)"
							(optionSelected)="toggleOption($event)"
							[focused]="focusedOption() === option"
							[attr.data-option-index]="option.index"
							[customOptionTemplate]="customOptionTemplate()"
							[fullWidth]="fullWidth()"
						>
						</ui-select-option>
					</div>
				}
			</div>
		}
	} @else {
		<div class="px-4 pb-2 pt-4" [hidden]="loading()" data-cy="select-no-data">
			<ui-notify [text]="translatedNoData()"></ui-notify>
		</div>
	}
	@if (loading()) {
		<div class="relative w-full h-10">
			<ui-spinner [size]="'s'"></ui-spinner>
		</div>
	}
</div>
